"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
var react_1 = require("react");
var useInterval = function (callback, delay) {
    var savedCallback = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        savedCallback.current = callback;
    }, [callback]);
    (0, react_1.useEffect)(function () {
        var tick = function () {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(tick, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
};
exports.useInterval = useInterval;
//# sourceMappingURL=index.js.map